const calcHeight = function(el) {
  const currentState = el.getAttribute('aria-expanded');

  el.classList.add('v-no-transition');
  el.removeAttribute('aria-expanded');
  el.style.height = null;
  el.style.height = el.clientHeight + 'px';
  el.setAttribute('aria-expanded', currentState);

  setTimeout(function() {
    el.classList.remove('v-no-transition');
  });
};

export default {
  inserted: function(el, binding) {
    if (binding.value !== null) {
      el.classList.add('expand');
      el.setAttribute('aria-expanded', binding.value ? 'true' : 'false');
      calcHeight(el);
      window.addEventListener('resize', () => calcHeight(el));
    }
  },
  update: function(el, binding) {
    if (el.style.height && binding.value !== null) {
      el.setAttribute('aria-expanded', binding.value ? 'true' : 'false');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/directives/expand/VueExpand.js